module.exports = __webpack_public_path__ + "img/HP NECKLACE RED.194da9e.svg";